import * as actionTypes from "./index";
import {actionCreator} from "../helpers/functions";

export const fetchGplPolicyDocuments = actionCreator(actionTypes.FETCH_GPL_POLICY_DOCUMENTS);
export const fetchGplPolicyDocumentsSuccess = actionCreator(actionTypes.FETCH_GPL_POLICY_DOCUMENTS_SUCCESS);
export const fetchGplPolicyDocumentsFailed = actionCreator(actionTypes.FETCH_GPL_POLICY_DOCUMENTS_FAILED);

// One document's bytes, requested on click. Separate from the list actions above because the list
// endpoint deliberately carries metadata only - see GplPolicyDocumentsService.GetDocuments.
export const fetchGplPolicyDocumentFile = actionCreator(actionTypes.FETCH_GPL_POLICY_DOCUMENT_FILE);
export const fetchGplPolicyDocumentFileSuccess = actionCreator(actionTypes.FETCH_GPL_POLICY_DOCUMENT_FILE_SUCCESS);
export const fetchGplPolicyDocumentFileFailed = actionCreator(actionTypes.FETCH_GPL_POLICY_DOCUMENT_FILE_FAILED);

// Dispatched when the modal closes. The modal is never unmounted (ModalWrapper renders
// <Modal fadeIn={isOpen}>), and the reducer otherwise resets only on LOCATION_CHANGE / LOGOUT -
// neither of which fires on close - so without this the error flags from one open are still set
// on the next one.
export const clearGplPolicyDocumentsState = actionCreator(actionTypes.CLEAR_GPL_POLICY_DOCUMENTS_STATE);
